/** Produkcyjny panel SellTracking 2.0 - tylko dla hostow w domenie vehis.pl. */
const MIGRATION_PROD_URL = 'https://selltracking2.vehis.pl';

/** Nieprodukcyjny panel SellTracking 2.0 - dla localhost, core-logic.io, corelogic.pl. */
const MIGRATION_NONPROD_URL = 'https://sellgps-traccar-dev.core-logic.io';

const PROD_HOSTNAME = /(^|\.)vehis\.pl$/i;

/**
 * Adres panelu 2.0 bierzemy z .env (REACT_APP_migrationURL), ustawianego per srodowisko.
 * Gdy zmiennej brak - np. dev server wystartowal przed jej dodaniem albo build poszedl
 * bez env-cmd - decyduje host: na produkcje przenosimy wylacznie z domeny vehis.pl,
 * z kazdego innego hosta (localhost, dev, uat, ata) na srodowisko nieprodukcyjne.
 * Koncowy ukosnik jest obcinany, zeby doklejane sciezki nie zrobily "//".
 */
export const MIGRATION_BASE_URL = (
    process.env.REACT_APP_migrationURL ||
    (PROD_HOSTNAME.test(window.location.hostname) ? MIGRATION_PROD_URL : MIGRATION_NONPROD_URL)
).replace(/\/+$/, '');



// WEBPACK FOOTER //
// ./src/components/MigrationModal/Services/migrationTarget.Service.ts